<template>
    <div class="header_margin-top">
      <div class="clearfix con-width-1200">
        <div class="public-title clearfix pos-rel">
          <h2 class="pos-rel course">{{ article.wenzbt}}</h2>
          <h1 class="pos-abs">{{ article.wenzbt }}</h1>
        </div>

        <div class="showHtml box-shadow rad5" v-html="article.wenznr" v-if="article.wenznr != null"></div>
        
        <div class="clear h10"></div>
      </div>
    </div>
  </template>
  
  <script>
    
  export default {
    name: "wenzxq",
    data() {
      return {
        article: {},
      };
    },
  
    created() {
        this.article = JSON.parse(localStorage.getItem('wenzxq')); 
    },
  
    methods: {
    }
  };
  </script>
  
  <style>
  a.return {
    font: normal 12px/30px "Microsoft YaHei";
    color: #0fb4b6;
  }
  
  .r-top {
    cursor: pointer;
    color: #0fb4b6;
    text-align: center;
    margin-left: 580px;
    background: rgba(239, 252, 248, 0.99);
    padding: 10px;
    font-size: 16px;
    margin: 40px 0px 20px 20px;
  }
  
  a.return:hover {
    color: #753f37;
  }
  
  .showHtml {
    border: 1px solid #d6e2df;
    background: #fffefc;
    padding: 30px 22px;
    text-align: left;
  }
  
  </style>
  